<template>
  <div>
    <v-card v-if="results.length >= 1 || results.length === null">
      <v-card-title class="text-25-security green-security font-weight-bold">
        <img src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/newspaper-solid.svg" alt="" class="icon-newpaper">
        Noticias
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          :label="message()"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="results"
        :search="search"
        disable-initial-sort
        class="elevation-1"
        no-data-text="Su búsqueda no dió resultados"
        rows-per-page-text="Filas por página"
      >
        <template slot="items" slot-scope="props">
          <tr @click="goToShowPost(props.item)">
            <td>
              {{ props.item.title }}
            </td>
            <td v-if="!$vuetify.breakpoint.smAndDown">
              {{ props.item.post_type }}
            </td>
            <td class="text-xs-left" v-if="!$vuetify.breakpoint.smAndDown">
              <p v-html="props.item.content.substring(0,120) + '...'" v-if="!props.item.content.includes('<video')"></p>
            </td>
            <td class="text-xs-right">
              {{ $vuetify.breakpoint.smAndDown ? props.item.published_at_mobile : props.item.published_at }}
            </td>
          </tr>
        </template>

        <v-layout slot="no-results">
          <v-flex sm12>
            <v-card flat>
              <v-layout align-center justify-center row wrap fill-height>
                <v-flex
                  sm12
                  class="text-29-security text-md-center font-weight-bold"
                  style="color: #525252"
                >Su búsqueda "{{ search }}" no arrojó resultados.</v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  data(){
    return{
      search: ""
    }
  },
  props: {
    results: {
      type: Array,
      required: false
    },
    headers: {
      type: Array,
      required: false
    }
  },
  methods: {
    ...mapMutations("posts", ["setPost"]),
    goToShowPost(post) {
      this.setPost(post);
      this.$router.push({
        name: "post-show",
        params: { id: post.id, slug: post.slug }
      });
    },
    message() {
      return `Mostrando resultados para ${this.$route.params.query}`;
    }
  }
}
</script>

<style>
.v-datatable tr {
  cursor: pointer;
}

.theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
  background: #e0f4ba;
}
.icon-newpaper{
  width: 36px;
  height: 28px;
  opacity: 0.54;
}
</style>